import { Box } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Body } from 'src/components/UI';
import Row from 'src/components/Row';
import { useLoyaltyRewardPointsQuery } from 'src/services/easyRewardsServices';
import { useRouter } from 'src/hooks';
import ROUTES from 'src/lib/routes';
import styles from '../styles.module.scss';

const QuestionInfoIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
    >
        <path
            d="M5 0C7.76142 0 10 2.23858 10 5C10 7.76142 7.76142 10 5 10C2.23858 10 0 7.76142 0 5C0 2.23858 2.23858 0 5 0ZM5 0.625C2.58375 0.625 0.625 2.58375 0.625 5C0.625 7.41625 2.58375 9.375 5 9.375C7.41625 9.375 9.375 7.41625 9.375 5C9.375 2.58375 7.41625 0.625 5 0.625ZM5 6.875C5.25888 6.875 5.46875 7.08487 5.46875 7.34375C5.46875 7.60263 5.25888 7.8125 5 7.8125C4.74112 7.8125 4.53125 7.60263 4.53125 7.34375C4.53125 7.08493 4.74102 6.8751 4.99982 6.875H5ZM4.82358 2.19773C5.61306 2.10802 6.34416 2.62508 6.52259 3.39936C6.70102 4.17363 6.26996 4.95852 5.52083 5.22338C5.39592 5.26754 5.31243 5.38568 5.3125 5.51833V5.9375C5.3125 6.11009 5.17259 6.25 5 6.25C4.82741 6.25 4.6875 6.11009 4.6875 5.9375V5.5185C4.68729 5.12102 4.93776 4.76661 5.3125 4.63412C5.76198 4.47521 6.02061 4.00428 5.91356 3.53971C5.8065 3.07515 5.36784 2.7649 4.89415 2.81873C4.42045 2.87256 4.06259 3.27332 4.0625 3.75006C4.06247 3.92265 3.92253 4.06253 3.74994 4.0625C3.57735 4.06247 3.43747 3.92253 3.4375 3.74994C3.43765 2.95537 4.03409 2.28745 4.82358 2.19773Z"
            fill="#585858"
        />
    </svg>
);

const RecyclingCartridgeEarningNew = () => {
    const { push } = useRouter();
    const [loyaltyRewardPoints, setLoyaltyRewardPoints] = useState<
        Record<any, number | string>
    >({});
    const { data: RewardPoints }: any = useLoyaltyRewardPointsQuery();

    useEffect(() => {
        setLoyaltyRewardPoints(RewardPoints?.[0]?.results?.[0]);
    }, [RewardPoints]);

    const handleStoreNavigation = () => {
        push(`${ROUTES.stores}#recycleData`);
    };
    return (
        <Box
            sx={{
                height: '100%',
            }}
            onClick={handleStoreNavigation}
        >
            <Box
                sx={{
                    mb: '10px',
                }}
            >
                <Row gap="6px">
                    <>
                        <Box
                            sx={{
                                height: '40px',
                            }}
                        >
                            <img
                                src={require('../../../assets/icons/recyleIcon.svg')}
                                alt="recycle icon"
                                height={'100%'}
                            />
                        </Box>
                    </>
                </Row>
            </Box>
            <Box
                sx={{
                    mb: '15px',
                }}
            >
                <Row direction="column" gap="4px">
                    <>
                        <Body
                            size={12}
                            lineHeight={18}
                            weight="bold"
                            color="textBlack"
                            className={styles.textUpperCase}
                        >
                            recycling
                        </Body>
                        <Row direction="column">
                            <>
                                <Body
                                    size={12}
                                    weight="light"
                                    lineHeight={16}
                                    color="#000000"
                                >
                                    {`Earn ${
                                        loyaltyRewardPoints?.points ||
                                        'additional'
                                    } points on each`}
                                </Body>
                                <Body
                                    size={12}
                                    weight="light"
                                    lineHeight={16}
                                    color="#000000"
                                >
                                    ink or toner cartridge, up
                                </Body>
                                <Row gap="4px" alignItems={'center'}>
                                    <>
                                        <Body
                                            size={12}
                                            weight="light"
                                            color="#000000"
                                            lineHeight={16}
                                        >
                                            {`to ${
                                                loyaltyRewardPoints?.maxnumberofcartridgesrecycled ||
                                                'a limit'
                                            } per month`}
                                        </Body>
                                    </>
                                </Row>
                            </>
                        </Row>
                    </>
                </Row>
            </Box>
        </Box>
    );
};

export default RecyclingCartridgeEarningNew;
